export default __webpack_public_path__ + "static/media/dom.ec68684a.png";